import React from 'react';
import styles from '../css/PatientChronicCards.module.css';

const getDaysOverdue = (dueDate) => {
  try {
    const now = new Date();
    const diff = Math.floor((now - dueDate) / (1000 * 60 * 60 * 24));
    return diff > 0 ? diff : 0;
  } catch {
    return 0;
  }
};

/**
 * PatientChronicCards
 * Props:
 *  - patients: Array<{ id, name, phone, dueDate: Date, quantity, status: 'Due'|'Overdue'|'Collected'|'Returned', scriptNo }>
 *  - onMarkCollected(id)
 *  - onReturnToInventory(id)
 */
const PatientChronicCards = ({ patients = [], onMarkCollected, onReturnToInventory, showScript = false }) => {
  return (
    <div className={styles.grid}>
      {patients.map((p) => {
        const initial = p.name?.[0]?.toUpperCase() || '?';
        const overdueDays = p.status === 'Overdue' ? getDaysOverdue(p.dueDate) : 0;
        const disabled = p.status === 'Collected' || p.status === 'Returned';
        const showReturn = p.status === 'Overdue';
        const scriptDisplay = (() => {
          const base = p.scriptNo != null ? String(p.scriptNo) : '';
          const rep = p.repeatNumber;
          if (base && rep != null && rep !== '') {
            return `${base}-${rep}`;
          }
          return base;
        })();
        return (
          <div key={p.id} className={styles.card}>
            <div className={styles.header}>
              <div className={styles.avatar}>{initial}</div>
              <div className={styles.name}>{p.name}</div>
              <div className={`${styles.status} ${p.status === 'Due' ? styles.statusDue : styles.statusOverdue}`}>
                {p.status}
              </div>
            </div>

            <div className={styles.body}>
              <div className={styles.row}>
                <span className={styles.icon}>📞</span>
                {p.phone}
                {showScript && (
                  <span className={styles.scriptTag} style={{ marginLeft: 'auto' }}>Script: {scriptDisplay}</span>
                )}
              </div>

              <br></br>

              <div className={styles.fields}>
                <div className={styles.fieldBox}>
                  <div className={styles.fieldLabel}>Due Date</div>
                  <div className={`${styles.inputLike} ${p.status === 'Overdue' ? styles.inputOverdue : ''}`}><span className={styles.icon}>📅</span>{p.dueDate.toISOString().slice(0,10)}</div>
                  {p.status === 'Overdue' && overdueDays > 0 && (
                    <div className={styles.overdueChip}>{overdueDays} days overdue</div>
                  )}
                </div>

                <div className={styles.fieldBox}>
                  <div className={styles.fieldLabel}>Total Quantity</div>
                  <div className={styles.inputLike}>{p.quantity}</div>
                </div>
              </div>
            </div>

            <div className={`${styles.footer} ${!showReturn ? styles.footerSingle : ''}`}>
              <button className={`${styles.btn} ${styles.btnPrimary}`} disabled={disabled} onClick={() => onMarkCollected?.(p.id)}>
                Mark Collected
              </button>
              {showReturn && (
                <button className={`${styles.btn} ${styles.btnPrimary}`} disabled={disabled} onClick={() => onReturnToInventory?.(p.id)}>
                  Return To Inventory
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PatientChronicCards;


